import { instanceAuth } from "api/apiConfig"

export const emailTemplatesFetchAPI = async data => {
  try {
    const response = await instanceAuth.get("EmailTemplate", {
      params: {
        ...data,
      },
    })
    return response
  } catch (error) {
    console.log("error fetching email templates...", error)
    throw error
  }
}

export const emailTemplateCreateAPI = async data => {
  try {
    const response = await instanceAuth.post("EmailTemplate", data)
    return response
  } catch (error) {
    console.log("error creating email template...", error)
    throw error
  }
}

export const emailTemplateUpdateAPI = async ({ id: id, data: data }) => {
  try {
    const response = await instanceAuth.put(`EmailTemplate/${id}`, data)
    return response
  } catch (error) {
    console.log("error updating email template...", error)
    throw error
  }
}

export const emailTemplateDeleteAPI = async id => {
  try {
    const response = await instanceAuth.delete(`EmailTemplate/${id}`)
    return response
  } catch (error) {
    console.log("error deleting email template...", error)
    throw error
  }
}
